module.exports = __webpack_public_path__ + "media/Blob 3 Joins.438d0459.mp3";